<script lang="ts">
	import '$lib/css/base.css';
	import '$vl/lib/css/generated/primitive-variables.css';
	import '$vl/lib/css/generated/semantic-variables.css';
	import '$vl/lib/css/vl-common.pcss';
	import Header from '$vl/lib/components/Header.svelte';
	import Footer from '$vl/lib/components/Footer.svelte';
	import { showFooter, showHeader } from '$lib/stores/layoutStore';
	import { PUBLIC_APP_ENV } from '$env/static/public';
	import { onMount } from 'svelte';
	import { platform } from '$lib/stores/platformStore';

	let { children } = $props();

	onMount(() => {
		const _platform = window.nudgePlatform;
		if (_platform) {
			_platform === 'android' ? ($platform = 'android') : ($platform = 'ios');
		} else {
			$platform = 'web';
		}
		console.log('platform', $platform);
	});
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
	<link
		href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap"
		rel="stylesheet"
	/>
	<link
		href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap"
		rel="stylesheet"
	/>
	<link rel="icon" href="/favicons/vl.png" />

	{#if PUBLIC_APP_ENV === 'production'}
		<script src="/newrelic-new.js" async></script>
	{/if}
</svelte:head>

{#if $platform == 'web'}
	{#if $showHeader}
		<Header />
	{/if}
{/if}

<main data-theme="vl">
	{@render children()}
</main>

{#if $platform == 'web'}
	{#if $showFooter}
		<Footer />
	{/if}
{/if}
